import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { generatepassword } from "../../../functions/auth";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Loading from "../../../modal/Loading";

const Generatepassword = () => {
  const location = useLocation();
  const naviagte = useNavigate();
  const { state } = location;
  const { userId, email } = state || {};
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");

  const generatePassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (password.length < 6) {
        setLoading(false);
        toast.error("Password should be minimum of 6 character");
      } else if (userId === undefined) {
        setLoading(false);
        toast.error("Geeting some error. Please request OTP again.");
      } else {
        await generatepassword(userId, password)
          .then((res) => {
            setLoading(false);
            // console.log(res);
            toast.success(res.data.data.message || "OTP changed successfully.");
            naviagte("/");
          })
          .catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error(
              err.response.data.message ||
                "Something went wrong. Please request OTP again."
            );
          });
      }
    } catch (error) {
      setLoading(false);
      toast.error(error);
    }
  };
  const forgotform = () => (
    <form>
      <div className="form-group mt-4">
        <input
          type="email"
          className="form-control"
          value={email}
          name="email"
          placeholder="Email"
          autoFocus
          autoComplete="true"
          disabled={userId !== ""}
        />
      </div>

      <div className="form-group mt-3">
        <input
          type="text"
          className="form-control"
          value={password}
          name="password"
          onChange={(e) => setPassword(e.target.value)}
          placeholder="New Password"
          autoFocus
          autoComplete="true" //off
        />
      </div>
      <button
        onClick={generatePassword}
        className="mb-3 mt-4 w-100 btnlogin"
        disabled={!password}
      >
        {loading ? <div>Processing....</div> : <div>Submit</div>}
      </button>
    </form>
  );

  console.log("===", userId, password);
  return (
    <div>
      {loading && <Loading />}
      <div className="container1">
        <div className="loginheader">
          <h2>Pronto</h2>
        </div>
        <div className="form-group mt-4"></div>
        <div className="pcont">
          <div className="p-4">
            <div className="row">
              <div className="col-md-4 offset-md-4">
                <div className="textJ">Generate New Password</div>
                <div
                  className="textJ mt-2"
                  style={{ fontSize: "12px", fontWeight: "400" }}
                >
                  Pronto by Health Monitor Network
                </div>

                {forgotform()}

                <div
                  className="textJ"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    textDecorationLine: "underline",
                    color: "black",
                  }}
                ></div>

                <div
                  className="textJ mt-1"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "black",
                  }}
                >
                  Admin Generate New password
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Generatepassword;
